// O'ng tugma menyulari (components/ui/context-menu + features/*/menu.ts), en — manba
export default {
  open: "Open",
  openNewTab: "Open in new tab",
  copyLink: "Copy link",
  copyPhone: "Copy phone",
  copyEmail: "Copy email",
  copyUsername: "Copy username",
  openProfile: "Open profile",
  openPersonProfile: "Open profile: {{name}}",
  openDriver: "Open driver: {{name}}",
  copyName: "Copy name",
  call: "Call",
  sendEmail: "Send email",
  copied: "Copied to clipboard",
  copyFailed: "Could not copy to clipboard",
  edit: "Edit",
  archive: "Archive",
  setStatus: "Set status",
  archiveTitle: "Archive {{name}}?",
  archivedToast: "{{name}} archived",
  statusChanged: "{{name}} → {{status}}",
  conflict: "Someone changed this record a moment ago. The list is refreshed — try again.",
  failed: "Action failed",
  placement: {
    addPayment: "Record a payment…",
    edit: "Fee terms…",
    writeOff: "Mark as not paid",
    reopen: "Reopen",
    payments: "Payments",
    voidPayment: "Cancel payment",
    awaitingApproval: "Awaiting hire approval",
  },
  driver: {
    logCall: "Log a call",
    addNote: "Add a note",
    addReminder: "Add a reminder",
    documents: "Documents",
    changeStatus: "Change status",
    moveTo: "Move to",
    markLost: "Mark as lost…",
    transfer: "Transfer to…",
    openJob: "Open job: {{title}}",
    openCarrier: "Open carrier: {{name}}",
    archiveTitle: "Archive {{name}}?",
    archiveDesc: "The driver disappears from lists, the pipeline and reports. The history stays in the audit log.",
    archived: "{{name}} archived",
  },
  activity: {
    title: "Log activity · {{name}}",
    type: "Type",
    types: { call: "Call", note: "Note", sms: "SMS", email: "Email" },
    outcome: "Outcome",
    minutes: "Minutes",
    body: "Notes",
    placeholderCall: "What did you talk about?",
    placeholderNote: "Write a note…",
    bodyRequired: "Write something for the note.",
    saved: "Saved to the driver's activity",
  },
  transfer: {
    title: "Transfer {{name}}",
    to: "New owner",
    pool: "Branch pool (no owner)",
    note: "Note for the new owner",
    current: "Current owner: {{name}}",
    nobody: "nobody",
    submit: "Transfer",
    done: "{{name}} → {{to}}",
    chooseUser: "Choose who gets the driver.",
  },
  task: {
    markDone: "Mark as done",
    snooze: "Snooze",
    reopen: "Reopen",
    addFollowUp: "Add a follow-up reminder",
    copyNote: "Copy note",
  },
  approval: {
    approve: "Approve…",
    reject: "Reject…",
    openBudget: "Open in Budget",
    copySummary: "Copy summary",
  },
  notification: {
    markRead: "Mark as read",
    markUnread: "Mark as unread",
    markAllRead: "Mark all as read",
    copyText: "Copy text",
  },
  truck: {
    openDriver: "Open driver: {{name}}",
    copyVin: "Copy VIN",
    copyPlate: "Copy plate",
  },
  carrier: {
    copyMc: "Copy MC number ({{mc}})",
    showJobs_one: "Show jobs ({{count}} open)",
    showJobs_other: "Show jobs ({{count}} open)",
    newJob: "New job for this carrier…",
    archiveDesc: "The carrier and its jobs disappear from lists. Submitted drivers and history stay.",
  },
  job: {
    submitDriver: "Submit a driver…",
    openCarrier: "Open carrier: {{name}}",
    archiveDesc: "The job disappears from lists and can no longer receive drivers. Applications stay in driver history.",
  },
  user: {
    showDrivers_one: "Show {{count}} driver",
    showDrivers_other: "Show {{count}} drivers",
    setPassword: "Set new password…",
    reset2fa: "Reset 2FA",
    reset2faTitle: "Reset 2FA for {{name}}?",
    reset2faDesc: "Their current authenticator will stop working. If 2FA is required for their role, they will set it up again at the next sign-in.",
    block: "Block…",
    unblock: "Unblock",
    access: "Permissions…",
  },
  branch: {
    openDashboard: "Open branch dashboard",
    openBudget: "Open branch budget",
    showUsers_one: "Show people ({{count}} recruiter)",
    showUsers_other: "Show people ({{count}} recruiters)",
    openReport: "Open branch report",
    people: "Show people",
  },
  budget: {
    reviewInApprovals: "Review in Approvals",
    openReceipt: "Open receipt",
    payExpense: "Pay from an account",
    copyAmount: "Copy amount",
    copyDescription: "Copy description",
    markPaid: "Mark as paid",
    markUnpaid: "Mark as unpaid",
    showDetails: "Show breakdown",
    hideDetails: "Hide breakdown",
    adjust: "Adjust…",
    approveBonus: "Approve this bonus",
  },
  audit: {
    showDetails: "Show details",
    openObject: "Open: {{name}}",
    filterActor: "Only actions by {{name}}",
    filterModel: "Only this object type",
    copyDetails: "Copy details (JSON)",
    copyRequestId: "Copy request ID",
  },
  import: {
    continue: "Continue import",
    openResult: "Open result",
    openSheet: "Open the sheet in Google",
    copySheetLink: "Copy sheet link",
  },
  recruiter: {
    showDrivers: "Show {{name}}'s drivers",
    openReport: "Open in Reports",
    focus: "Show only {{name}}",
  },
  report: {
    sourceDrivers: "Show drivers from {{source}}",
    carrierJobs: "Show carrier jobs",
  },
  portal: {
    details: "Open details",
    accept: "Accept…",
    reject: "Reject…",
    copyTitle: "Copy job title",
    copyPay: "Copy pay",
  },
  application: {
    copyReply: "Copy carrier reply",
  },
  activityItem: {
    copyText: "Copy text",
  },
};
